import AcademicInfo from './component';
import _routes from './routes';

export default AcademicInfo;

export const routes = _routes;



// WEBPACK FOOTER //
// ./containers/UserDashboard/AcademicInfo/index.js